export default __webpack_public_path__ + "static/media/picture.97e4fae1.svg";